import React, { useState } from "react";
import Moment from "react-moment";

const List = ({ list, translations }) => {
  const validDateTranslation = translations?.find(
    (translation) => translation.Key === "ValidDate"
  );
  const issuedDateTranslation = translations?.find(
    (translation) => translation.Key === "IssuedDate"
  );
  const emptyListMessage = translations?.find(
    (translation) => translation.Key === "EmptyListMessage"
  );
  const [downloadedItems, setDownloadedItems] = useState([]);

  const setToDownloaded = (link) => {
    setDownloadedItems([...downloadedItems, link]);
  };
  return (
    <>
      {list?.length > 0 ? (
        list &&
        list.map((item, index) => (
          <div className="list-page__item file-item" key={index}>
            <div className="filedownloadblock__grid-item">
              <div className="filedownloadblock__image"></div>
              <a
                className="filedownloadblock__button"
                href={item.Link}
                target={episerver_linkTarget}
                download
                onClick={() => setToDownloaded(item.Link)}
              >
                <div className="filedownloadblock__content">
                  <div className="download-block-text date">
                    <div>
                      <Moment
                        className="date_text"
                        locale={episerver_local}
                        format="DD MMMM, yyyy"
                      >
                        {item.Date}
                      </Moment>
                      <span className="document_type_filter">
                        {item.DocumentType}
                      </span>
                    </div>
                    {item.ValidityDate != "0001-01-01" && (
                      <span className="valid_to">
                        {validDateTranslation?.Translation} {item.ValidityDate}
                      </span>
                    )}
                    {item.IssuedDate != "0001-01-01" && (
                      <span className="valid_to">
                        {issuedDateTranslation?.Translation} {item.IssuedDate}
                      </span>
                    )}
                  </div>
                  <span className="download-block-text metadata">
                    {item.Title}
                  </span>
                </div>
                {downloadedItems.includes(item.Link) ? (
                  <div className="filedownloadblock__icon">
                    <img src="/Static/icons/tick.gif" />
                  </div>
                ) : (
                  <div className="filedownloadblock__icon">
                    <img src="/Static/icons/download.svg" />
                  </div>
                )}
              </a>
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            textAlign: "center",
            paddingBlock: "2rem",
            fontSize: "1.5rem",
          }}
        >
          <p>{emptyListMessage?.Translation}</p>
        </div>
      )}
    </>
  );
};

export default List;
